export enum apartmentType {
    oneBedroom = "OneBedroom",
    studio = "Studio",
}
